module.exports = __webpack_public_path__ + "static/img/icon-c-mobile.23d4876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-c-mobile.png
// module id = ZtZ+
// module chunks = 21